import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

/**
 * Quick-add for the cart drawer recommendations. Mirrors product-form.js: posts to cart/add with
 * the cart sections, then resolves a CartLinesUpdateEvent so the drawer re-renders in place.
 */
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-jes-rec-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  const label = button.innerHTML;
  button.disabled = true;
  if (!button.hasAttribute('data-jes-open-drawer')) button.textContent = 'Adding…';

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
    .filter(Boolean);

  const formData = new FormData();
  formData.append('id', button.dataset.jesRecAdd || '');
  formData.append('quantity', '1');
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: button.dataset.jesRecAdd || '', quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const cfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...cfg,
      headers: { ...cfg.headers, Accept: 'text/html' },
    }).then((r) => r.json());
    if (response.status) throw new Error(response.message || 'Add to cart failed');

    const cart = await fetch(`${Theme.routes.cart_url}.json`).then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'jes-cart-recs',
        sourceId: 'jes-cart-recs',
        itemCount: 1,
        sections: response.sections,
        didError: false,
      },
    });
    if (button.hasAttribute('data-jes-open-drawer')) {
      button.disabled = false;
      const drawer = document.getElementById('cart-drawer');
      if (drawer && 'open' in drawer && !drawer.isOpen) drawer.open();
    }
  } catch (error) {
    console.error(error);
    deferred.reject(error);
    button.disabled = false;
    button.innerHTML = label;
  }
});
